import axios from 'axios';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

// Lanza, consulta y cancela una notificación masiva de actualización de Términos y
// Condiciones — consume la API admin ya construida en pawer-backend
// (085-notify-terms-update). Este servicio no agrega lógica de negocio, solo
// transporte (Constitution I).
export default class TermsNotificationService {
  static async launch({ link, message }) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const response = await axios.post(
        `${ADMIN_URL}/terms-notifications/send`,
        { link, message },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      const apiError = error?.response?.data?.error;
      return {
        status: 'error',
        code: apiError?.code,
        message: apiError?.message,
        data: apiError?.existingRunId ? { existingRunId: apiError.existingRunId } : undefined
      };
    }
  }

  static async getStatus(runId) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const response = await axios.get(`${ADMIN_URL}/terms-notifications/${runId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      const apiError = error?.response?.data?.error;
      return { status: 'error', code: apiError?.code, message: apiError?.message };
    }
  }

  static async cancel(runId) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const response = await axios.post(
        `${ADMIN_URL}/terms-notifications/${runId}/cancel`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      const apiError = error?.response?.data?.error;
      return { status: 'error', code: apiError?.code, message: apiError?.message };
    }
  }
}
